var _path, _path2, _path3, _path4, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconCookieHead = function SvgIconCookieHead(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 42,
    viewBox: "0 0 29 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82422 24.9531L9.21814 35.1951C9.34945 35.4577 9.76963 35.9829 10.3999 35.9829C11.0302 35.9829 13.026 35.9829 13.9452 35.9829C14.2078 35.8516 14.8182 35.5102 14.8182 35.1951C14.8182 35.0973 14.8182 33.6194 14.8182 33.6194M14.8182 33.6194C14.8182 31.6816 14.8182 28.4306 14.8182 26.5288V33.6194ZM14.8182 33.6194C14.8182 34.1446 15.0546 35.1951 16 35.1951C16.9454 35.1951 19.1975 35.1951 20.2479 35.1951C20.3792 35.1951 20.6419 34.9587 20.6419 34.0133C20.6419 33.0679 20.6419 27.8419 20.6419 25.347",
    stroke: "#3C3C3B",
    strokeWidth: 0.787842
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0064 37.953C9.06097 37.3227 9.61246 36.3773 10.0064 35.9834H13.9456L16.3091 37.5591C17.4909 38.3469 16.3091 39.1348 14.7334 39.1348C13.1578 39.1348 11.1881 38.7408 10.0064 37.953Z",
    fill: "#3C3C3B",
    stroke: "#3C3C3B",
    strokeWidth: 0.787842
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0434 35.1954L16.0435 35.1953H19.9827C20.3766 35.4579 21.4008 35.7467 22.3462 36.377C23.528 37.1648 22.3462 37.9527 20.7705 37.9527C19.1949 37.9527 17.2253 37.5587 16.0435 36.7709C15.0981 36.1407 15.6495 35.5893 16.0434 35.1954Z",
    fill: "#3C3C3B",
    stroke: "#3C3C3B",
    strokeWidth: 0.787842
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83025 6.50875C2.7451 7.40924 2.10958 10.3726 2.05246 11.7417C1.62408 22.01 8.21473 27.6337 16.7829 26.7568C25.3511 25.8799 27.3847 17.7872 27.5218 14.5013C27.7303 9.50453 24.8151 7.80526 22.8059 4.84131C20.7966 1.87736 14.8301 1.98858 11.8493 1.86422C8.86841 1.73986 7.43668 5.38315 4.83025 6.50875Z",
    fill: "#F1FFFF",
    stroke: "#3C3C3B",
    strokeWidth: 0.822179
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_379_37238",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 27,
    height: 27
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83025 6.50875C2.7451 7.40924 2.10958 10.3726 2.05246 11.7417C1.62408 22.01 8.21473 27.6337 16.7829 26.7568C25.3511 25.8799 27.3847 17.7872 27.5218 14.5013C27.7303 9.50453 24.8151 7.80526 22.8059 4.84131C20.7966 1.87736 14.8301 1.98858 11.8493 1.86422C8.86841 1.73986 7.43668 5.38315 4.83025 6.50875Z",
    fill: "#F6EEE4",
    stroke: "#303030",
    strokeWidth: 0.822179
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_379_37238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.52427 14.1741C1.57911 12.8598 2.44449 12.5667 2.87033 12.5845C4.11357 13.4593 3.60206 15.4952 2.73325 15.8704C1.86443 16.2456 1.45573 15.8171 1.52427 14.1741Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04638 21.4408C7.05178 20.741 7.67766 20.054 8.11492 19.7979C9.81827 19.869 10.6357 20.726 11.0272 21.5652C11.4188 22.4044 9.28962 22.3156 8.04638 21.4408Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3713 19.6892C14.9089 19.2044 15.2636 18.8618 15.8485 18.4748C15.9962 18.3438 16.7957 18.2674 17.1089 18.9388C17.5005 19.778 15.78 20.1177 15.3713 19.6892Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1637 24.3316C17.4686 24.6318 17.5331 25.8139 17.6522 26.3675C18.5038 26.403 20.6673 25.6704 20.6844 25.2597C20.7016 24.8489 19.0325 23.9564 18.1637 24.3316Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3389 16.2768C22.38 15.2911 23.2534 14.8064 23.685 14.6872C24.5367 14.7227 24.5024 15.5442 24.4681 16.3657C24.4338 17.1871 23.5308 18.3838 23.1049 18.366C22.6791 18.3483 22.2875 17.509 22.3389 16.2768Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1246 7.66924C22.8113 6.99786 23.5847 6.86554 24.0105 6.88331C24.425 7.17489 25.3355 7.84377 25.6625 8.18657C26.0712 8.61506 25.1852 9.401 24.3336 9.36547C23.4819 9.32993 23.5162 8.50847 23.1246 7.66924Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0772 9.47418C16.7502 9.13139 17.2591 8.52173 17.5544 8.25975C17.7021 8.12876 18.0792 7.95249 18.4061 8.29528C18.8148 8.72378 18.7805 9.54525 18.3376 9.93821C17.8946 10.3312 17.4859 9.90268 17.0772 9.47418Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.927 13.7435C10.9544 13.0863 11.8243 12.6838 12.2559 12.5646C13.5334 12.6179 13.925 13.4571 14.3165 14.2964C14.7081 15.1356 12.5789 15.0468 12.1359 15.4397C11.693 15.8327 10.8927 14.565 10.927 13.7435Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62898 7.47595C7.98876 6.46176 8.9757 5.98177 9.5492 5.86855C10.1923 5.62238 11.6612 6.36811 12.07 6.79661C12.4787 7.2251 11.1669 7.99327 10.2809 8.7792C9.39498 9.56514 9.42925 8.74367 8.62898 7.47595Z",
    fill: "#3C3C3B"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconCookieHead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-cookie-head.506be9e13388f3ff135297434b0ab112.blank.svg";